import React from 'react';

/**
 * loading / error / empty состояния «Сводки». ТЗ №1 §12.2: ошибка и пустой
 * результат — разные состояния, 5xx не показывается как нули.
 */
const SummaryStateBlock = ({
  state, message, onRetry, onReset, resetLabel = 'Сбросить', resetIcon = null,
}) => {
  if (state === 'loading') {
    return (
      <div className="sum-state sum-state--loading" role="status" aria-live="polite">
        <span className="sum-visually-hidden">Загрузка</span>
        <div className="sum-skeleton" />
        <div className="sum-skeleton" />
        <div className="sum-skeleton" />
      </div>
    );
  }

  if (state === 'error') {
    return (
      <div className="sum-state sum-state--error" role="alert">
        <p className="sum-state-text">{message || 'Не удалось загрузить данные'}</p>
        <div className="sum-state-actions">
          {onRetry && (
            <button type="button" className="sum-btn sum-btn--primary" onClick={onRetry}>Повторить</button>
          )}
          {onReset && (
            resetIcon ? (
              <button
                type="button"
                className="sum-btn sum-btn--square"
                onClick={onReset}
                title={resetLabel}
                aria-label={resetLabel}
              >
                {resetIcon}
              </button>
            ) : (
              <button type="button" className="sum-btn" onClick={onReset}>{resetLabel}</button>
            )
          )}
        </div>
      </div>
    );
  }

  if (state === 'empty') {
    return (
      <div className="sum-state sum-state--empty">
        <p className="sum-state-text">{message}</p>
      </div>
    );
  }

  return null;
};

export default SummaryStateBlock;
